<h3 class="title-h3">{{'bookingPayment.title.paymentWithBankTransfer' | ibeadmin | async}}</h3>

<p>{{'bookingPayment.text.afterClickingOnThe' | ibeadmin | async}} <span class="bold">“{{'bookingPayment.text.confirmBooking' | ibeadmin | async}}”</span> {{'bookingPayment.text.buttonWillBeRedirected' | ibeadmin | async}} <span
		class="bold">{{'bookingPayment.text.safetyPay' | ibeadmin | async}}</span> {{'bookingPayment.text.confirmBanktransfer' | ibeadmin | async}}</p>

<div class="payment-option__wrapper">
	<p class="description no-margin">{{'bookingPayment.text.via' | ibeadmin | async}}</p>
	<app-svg class="payment-option-logo" svg="sprite.svg#payment_method--safety_pay" [alt]="'Safety Pay logo'"></app-svg>
</div>

<div class="form-field--row grid no-padding bottom-gap">
	<div class="form-field col-12 payment-card-types-wrapper">
		<label class="description no-margin">{{'bookingPayment.text.safetyPayOnlyAvailable' | ibeadmin | async}}</label>
		<div class="payment-card-types-list">
			<div *ngFor="let card of cardsType" class="payment-card-type" tooltip="{{ cardBrands[card].name }}">
				<app-svg class="payment-option-card-image" svg="sprite.svg#credit_card--{{ card }}"
					[alt]="cardBrands[card].name + ' logo'"></app-svg>
			</div>
		</div>
	</div>
</div>

<div class="payment-option__conditions-wrapper" [class.has-error]="!(formIsValid$ | async)">
	<div class="payment-option__conditions">
		<app-checkbox-input (change)="INDRA_acceptTermsAndConditionsChange($event)" label="" [class.has-error]="!(formIsValid$ | async)"></app-checkbox-input>
		<span>
			{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
			<a class="link" href="javascript:;" 
				(click)="INDRA_handleBookingTicketConditions()"
				attr.aria-label="{{'bookingPayment.aria.openFare' | ibeadmin | async}}'" role="button">
				{{'bookingPayment.text.fareConditions' | ibeadmin | async}}
			</a> {{'bookingPayment.text.andThe' | ibeadmin | async}} 
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.transportConditions')"
				attr.aria-label="{{'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async}}">
				{{'bookingPayment.text.tncCarriage' | ibeadmin | async}}
			</a> 
			<!--{{'bookingPayment.text.andThe' | ibeadmin | async}}
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
				{{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
			</a>-->
			<ng-container *ngIf="displayCovidTermsAndCondition">
				, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
					{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
				</a>
				{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
			</ng-container>
		</span>
	</div>
</div>
